const config = {
    appUrl : "http://localhost:3000",
    // apiUrl : "https://api.webweb.ai"
    apiUrl : "https://blossom-api.skyq.tech"
}
  
export default config